import { render } from "./SafeHtml.vue?vue&type=template&id=c8163ef2"
import script from "./SafeHtml.vue?vue&type=script&lang=js"
export * from "./SafeHtml.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__